import React from 'react';

export default function PrintBrandHeader() {
  return (
    <div className="print-brand-header" aria-hidden="true">
      <img src="/damyar-logo-full.jpeg" alt="دام یار" className="print-brand-header__logo" />
      <div className="print-brand-header__meta">
        <div className="print-brand-header__title">دام یار</div>
        <div className="print-brand-header__subtitle">سامانه جامع مدیریت دامداری</div>
      </div>
    </div>
  );
}
